import React, {Component} from 'react';

class Pwa extends Component {
  constructor(props){
    super(props)
    this.state = {
      installButton: false
    }

  }

  componentDidMount() {
    this.installPrompt = null;
    console.log("Listening for Install prompt");
  
    window.addEventListener('beforeinstallprompt', e => {
      // For older browsers
      e.preventDefault();
      console.log("Install Prompt fired");
      this.installPrompt = e;
      // See if the app is already installed, in that case, do nothing
      if ((window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) || window.navigator.standalone === true) {
        return false;
      }
      // Set the state variable to make button visible
      this.setState({
        installButton: true
      })
    })

    const noBtn = document.querySelector('.btn-no');
    const yesBtn = document.querySelector('.btn-yes');

    noBtn.addEventListener('click', (e) => {
      this.installPrompt = null;
      this.setState({
        installButton: this.installPrompt
      })
    })

    yesBtn.addEventListener('click', (e) => {
      console.log('clickEvent')
      // hide our user interface that shows our A2HS button

      this.installPrompt.prompt();
      // Wait for the user to respond to the prompt
      this.installPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === 'accepted') {
          console.log('User accepted the A2HS prompt');
        } else {
          console.log('User dismissed the A2HS prompt');
        }
        this.installPrompt = null;
        this.setState({
          installButton: this.installPrompt
        })
      });
    });

    
  }

  render() {
    const className = this.state.installButton ? "visible" : "hidden"
    return ( 
      <div className = {
          "install-prompt " + className
        } >
        <div> Hi there! Add to home screen? </div> 
        <button className="btn-no">nope</button> 
        <button className="btn-yes">install</button> 
      </div>
    );
  }
}

export default Pwa;


// WEBPACK FOOTER //
// ./src/components/ui/Pwa.js